module.exports = __webpack_public_path__ + "img/21.549a977f.jpg";